(function() {

  'use strict';

  // Konfiguration
  const CONFIG = {
    duration: 2000, // Millisekunden für die Animation
    easingPower: 3   // Höher = stärkerer ease-out Effekt
  };

  // Ease-out Funktion
  function easeOut(t) {
    return 1 - Math.pow(1 - t, CONFIG.easingPower);
  }

  // Zahl formatieren mit lokalem Format
  function formatNumber(value, decimals) {
    return new Intl.NumberFormat(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    }).format(value);
  }

  // Animation für eine einzelne Zahl
  function animateNumber(element) {
    const targetValue = parseFloat(element.dataset.value);
    if (isNaN(targetValue)) return;

    // Dezimalstellen aus dem Original-Wert ermitteln
    const decimalPlaces = (element.dataset.value.split('.')[1] || element.dataset.value.split(',')[1] || '').length;

    const startTime = performance.now();
    const startValue = 0;

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / CONFIG.duration, 1);
      const easedProgress = easeOut(progress);

      const currentValue = startValue + (targetValue - startValue) * easedProgress;
      element.textContent = formatNumber(currentValue, decimalPlaces);

      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        element.textContent = formatNumber(targetValue, decimalPlaces);
      }
    }

    requestAnimationFrame(update);
  }

  // Intersection Observer Setup
  const observer = new IntersectionObserver(numbers => {
    numbers.forEach(number => {
      if (number.isIntersecting) {
        if (!number.target.dataset.animated) {
          number.target.dataset.animated = 'true';
          animateNumber(number.target);
        }
        observer.unobserve(number.target);
      }
    });
  }, {threshold: 0.2, rootMargin: '0px'});

  // Alle Quick Facts Zahlen beobachten
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.nxa-block-quick-facts .number').forEach(number => observer.observe(number));
  });

})();
